var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.onMobile)?_c('feedback-button',{attrs:{"logId":_vm.logId},on:{"close":_vm.handleClose}}):_c('feedback-card',{attrs:{"logId":_vm.logId,"on-mobile":_vm.onMobile},on:{"close":_vm.handleClose}})}
var staticRenderFns = []

export { render, staticRenderFns }